import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('koloth_cookie_consent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('koloth_cookie_consent', 'accepted');
    localStorage.setItem('koloth_consent_date', new Date().toISOString());
    setShowConsent(false);
  };

  const declineCookies = () => {
    localStorage.setItem('koloth_cookie_consent', 'declined');
    localStorage.setItem('koloth_consent_date', new Date().toISOString());
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <Card className="bg-white border-2 border-blue-200 shadow-xl">
        <CardContent className="p-4">
          <div className="flex flex-col md:flex-row md:items-center justify-between space-y-3 md:space-y-0 md:space-x-4">
            <div className="flex-1">
              <h4 className="font-semibold text-slate-800 mb-1">🍪 Cookie Notice</h4>
              <p className="text-sm text-slate-600">
                We use essential cookies to ensure our website works properly and to keep you logged in. 
                We don't use tracking cookies or share your data with third parties.
                <span className="ml-1">
                  <button 
                    className="text-blue-600 hover:text-blue-800 underline"
                    onClick={() => window.open('#privacy-policy', '_blank')}
                    data-testid="cookie-privacy-link"
                  >
                    Learn more
                  </button>
                </span>
              </p>
            </div>
            <div className="flex space-x-2 flex-shrink-0">
              <Button 
                variant="outline" 
                size="sm" 
                onClick={declineCookies}
                data-testid="decline-cookies"
                className="text-slate-600 border-slate-300 hover:bg-slate-50"
              >
                Decline
              </Button>
              <Button 
                size="sm" 
                onClick={acceptCookies}
                data-testid="accept-cookies"
                className="bg-blue-600 hover:bg-blue-700"
              >
                Accept
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CookieConsent;